export default {"src":"/_next/static/media/3_Arrow.f5743a08.svg","height":191,"width":126};